module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    attrs: {
      "id": "pledge-wrap"
    }
  }, [_c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1 pure-u-lg-13-24",
    attrs: {
      "id": "pledge-text"
    }
  }, [_c('table', {
    attrs: {
      "id": "runners-info"
    }
  }, [_c('tr', [_c('td', [(this.sharedState.wasReferred) ? _c('p', [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.sharedState.wasReferred && this.sharedState.referralUser.photo),
      expression: "this.sharedState.wasReferred && this.sharedState.referralUser.photo"
    }],
    attrs: {
      "src": this.sharedState.referralUser.photo,
      "id": "referralImage"
    }
  }), _vm._v(" " + _vm._s(_vm._f("firstName")(this.sharedState.referralUser.name)) + " and\n                ")]) : _vm._e(), _vm._v(" "), _c('p', {
    class: _vm.resizeCounter(),
    attrs: {
      "id": "total-runners"
    }
  }, [_vm._v(_vm._s(_vm.formattedTotalPeople))]), _vm._v(" "), _c('p', [_vm._v("people will be running in " + _vm._s(this.sharedState.year))])])])]), _vm._v(" "), _c('div', {
    staticClass: "pledge-footer noSelect"
  }, [_c('ul', {
    attrs: {
      "id": "footer-social"
    }
  }, [_c('li', {
    staticClass: "twitter",
    on: {
      "click": function($event) {
        _vm.share('twitter')
      }
    }
  }, [_c('span', {
    staticClass: "icon-twitter"
  }), _vm._v(" Tweet")]), _vm._v(" "), _c('li', {
    staticClass: "facebook",
    on: {
      "click": function($event) {
        _vm.share('facebook')
      }
    }
  }, [_c('span', {
    staticClass: "icon-facebook-official"
  }), _vm._v(" Share")]), _vm._v(" "), _c('li', {
    staticClass: "linkedin",
    on: {
      "click": function($event) {
        _vm.share('linkedin')
      }
    }
  }, [_c('span', {
    staticClass: "icon-linkedin-squared"
  }), _vm._v(" Share")])])])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-lg-11-24",
    attrs: {
      "id": "pledge-form"
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isPledgeCompleted),
      expression: "!this.isPledgeCompleted"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "id": "form",
      "name": "emailForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.pledge('password')
      }
    }
  }, [(this.pledgeVia === 'password') ? _c('div', {
    staticClass: "pure-g",
    attrs: {
      "id": "manualForm"
    }
  }, [_c('div', {
    staticClass: "pure-u-2-5 inputWrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.name),
      expression: "newUser.name"
    }],
    staticClass: "inputField name",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Name"
    },
    domProps: {
      "value": _vm._s(_vm.newUser.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-3-5 inputWrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    staticClass: "inputField email",
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "Email address"
    },
    domProps: {
      "value": _vm._s(_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.email = $event.target.value
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "noSelect",
    attrs: {
      "id": "pledgeButtons"
    }
  }, [(this.pledgeVia === 'facebook.com') ? _c('div', [_c('div', {
    staticClass: "button facebook"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.pledge('facebook.com')
      }
    }
  }, [_vm._v("Pledge to run via Facebook")]), _vm._v(" "), _c('icon', {
    attrs: {
      "type": "icon-facebook",
      "dropdown": "true"
    }
  })])]) : (this.pledgeVia === 'twitter.com') ? _c('div', [_c('div', {
    staticClass: "button twitter"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.pledge('twitter.com')
      }
    }
  }, [_vm._v("Pledge to run via Twitter")]), _vm._v(" "), _c('icon', {
    attrs: {
      "type": "icon-twitter",
      "dropdown": "true"
    }
  })])]) : (this.pledgeVia === 'google.com') ? _c('div', [_c('div', {
    staticClass: "button google"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.pledge('google.com')
      }
    }
  }, [_vm._v("Pledge to run via Google")]), _vm._v(" "), _c('icon', {
    attrs: {
      "type": "icon-google",
      "dropdown": "true"
    }
  })])]) : (this.pledgeVia === 'password') ? _c('div', [_c('div', {
    staticClass: "button email"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.pledge('password')
      }
    }
  }, [_vm._v("Pledge to run")]), _vm._v(" "), _c('icon', {
    attrs: {
      "type": "icon-mail",
      "dropdown": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pledgeVia),
      expression: "pledgeVia"
    }],
    attrs: {
      "name": "pledgeOptions",
      "id": "pledgeOptions"
    },
    on: {
      "change": function($event) {
        _vm.pledgeVia = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "facebook.com"
    }
  }, [_vm._v("Pledge via Facebook")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "twitter.com"
    }
  }, [_vm._v("Pledge via Twitter")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "google.com"
    }
  }, [_vm._v("Pledge via Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "password"
    }
  }, [_vm._v("Pledge via Email address ")])])]), _vm._v(" "), ((this.pledgeVia === 'password' && _vm.showErrors)) ? _c('ul', {
    staticClass: "errors"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.name),
      expression: "!validation.name"
    }]
  }, [_vm._v("Name cannot be empty.")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.email),
      expression: "!validation.email"
    }]
  }, [_vm._v("Please provide a valid email address.")])]) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isPledgeCompleted),
      expression: "this.isPledgeCompleted"
    }]
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "bottomMargin"
  }, [_vm._v("Share your pledge to run in " + _vm._s(this.sharedState.year) + " and encourage people like you get fit and stay healthy.")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "shareButtons"
    }
  }, [_c('div', [_c('div', {
    staticClass: "button facebook"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.share('facebook')
      }
    }
  }, [_c('icon', {
    attrs: {
      "type": "icon-facebook",
      "dropdown": "false"
    }
  }), _vm._v("\n                    Share on Facebook\n                  ")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "button twitter"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.share('twitter')
      }
    }
  }, [_c('icon', {
    attrs: {
      "type": "icon-twitter",
      "dropdown": "false"
    }
  }), _vm._v("\n                    Share on Twitter\n                  ")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "button linkedin"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.share('linkedin')
      }
    }
  }, [_c('icon', {
    attrs: {
      "type": "icon-linkedin",
      "dropdown": "false"
    }
  }), _vm._v("\n                    Share on LinkedIn\n                  ")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "shareLink"
  }, [_c('input', {
    staticClass: "inputField",
    attrs: {
      "type": "text",
      "name": "shareLink",
      "readonly": "readonly",
      "placeholder": "URL here",
      "onClick": "this.setSelectionRange(0, 9999)"
    },
    domProps: {
      "value": this.getSharingUrl()
    }
  })])])])]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.isPledgeCompleted),
      expression: "!this.isPledgeCompleted"
    }]
  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v("Running is a great free way to get fit and healthy. Take this pledge to show your determination, get reminders about your runs and access useful resources to get you started.\n            "), _c('br'), _c('br'), _c('read-more', {
    attrs: {
      "newLine": "true"
    }
  }, [_vm._v("\n              To get you started we have curated a list of " + _vm._s(this.sharedState.totalResources) + " resources (and growing) including races, apps, clothing and tips & tricks to avoid injuries. To access this list, make sure you pledge to run in " + _vm._s(this.sharedState.year) + ".\n              "), _c('br'), _c('br'), _vm._v("\n              If you have any suggestion, would like to help us get more people fit or have found a race, accessory, or article you think we should cover, "), _c('a', {
    attrs: {
      "href": "mailto:run@runningyear.com",
      "target": "new"
    }
  }, [_vm._v("please get in touch")]), _vm._v(".\n            ")])])]), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "pledge-footer"
  }, [_c('ul', {
    attrs: {
      "id": "footer-email"
    }
  }, [_c('li', {
    staticClass: "email",
    on: {
      "click": function($event) {
        _vm.share('email')
      }
    }
  }, [_c('span', {
    staticClass: "icon-mail"
  }), _vm._v(" Share by Email")])])])])]), _vm._v(" ")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h3', [_c('span', [_vm._v("Pledge to run")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    attrs: {
      "id": "privacy"
    }
  }, [_c('label', {
    staticClass: "icon-lock"
  }), _vm._v(" "), _c('p', [_c('i', [_vm._v("We will "), _c('b', [_vm._v("not")]), _vm._v(" post anything on your behalf")]), _vm._v(", spam or share your details with third parties.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h3', [_c('span', [_vm._v("Encourage others to run")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h3', [_c('span', [_vm._v("Why pledge to run?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e918fb8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pledge.vue
// module id = 109
// module chunks = 2